// CollaborationNotifications.tsx
import React from "react";
import { Dialog, IconButton, Snackbar } from "@material-ui/core";
import MuiAlert from "@mui/material/Alert";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import CloseIcon from "@mui/icons-material/Close";
import { tokens } from "../../theme/tokens";

interface CollaborationNotificationsProps {
  userInCaseOpen: {
    status: boolean;
    showSnackbar: boolean;
    message: string;
    showAvatar: boolean;
    primary: boolean;
  };
  handleClose: (event?: React.SyntheticEvent, reason?: string) => void;
}

const CollaborationNotifications: React.FC<CollaborationNotificationsProps> = ({
  userInCaseOpen,
  handleClose,
}) => {
  return (
    <>
      {/* Snackbar for brief notifications */}
      <Snackbar
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        open={userInCaseOpen.showSnackbar}
        autoHideDuration={2000}
        onClose={handleClose}
      >
        <MuiAlert severity="info">{userInCaseOpen.message}</MuiAlert>
      </Snackbar>

      {/* Dialog for persistent notifications */}
      <Dialog
        open={userInCaseOpen.status}
        onClose={(event, reason) => {
          if (reason !== "backdropClick" && reason !== "escapeKeyDown") {
            handleClose();
          }
        }}
      >
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignContent: "center",
            backgroundColor: tokens.color.brand.primary,
            alignItems: "center",
            padding: `${tokens.space[1]} ${tokens.space[2]}`,
          }}
        >
          <InfoOutlinedIcon style={{ color: tokens.color.brand.onPrimary }} />
          <div style={{ color: tokens.color.brand.onPrimary, padding: tokens.space[2] }}>
            {userInCaseOpen.message}
          </div>
          <IconButton onClick={handleClose}>
            <CloseIcon style={{ color: tokens.color.brand.onPrimary }} />
          </IconButton>
        </div>
      </Dialog>
    </>
  );
};

export default CollaborationNotifications;
